import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { EstatusTarea } from 'app/oDres/modelos/Catalogos/estatusTarea';
import { PrioridadTarea } from 'app/oDres/modelos/Catalogos/prioridadTarea';
import { Tareas } from 'app/oDres/modelos/Empresa/tareas';
import { UsuariosTareasAdmin } from 'app/oDres/modelos/Empresa/usuariosTareasAdmin';
import { ResultadoPaginado } from 'app/oDres/modelos/Generales/resultadoPaginado';
import { AuthService } from 'app/shared/auth/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as R from 'ramda';
import { Usuario } from 'app/oDres/modelos/Empresa/usuarios';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import swal, { SweetAlertOptions } from 'sweetalert2';
import { TareaXUsuarioDirigidoA } from 'app/oDres/modelos/Empresa/tareaXUsuarioDirigidoA';
import { TareasXDocumento } from 'app/oDres/modelos/Empresa/tareasXDocumento';
import { Documento } from 'app/oDres/modelos/Empresa/documento';
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexXAxis,
  ApexPlotOptions,
  ApexStroke,
  ApexTitleSubtitle,
  ApexYAxis,
  ApexTooltip,
  ApexFill,
  ApexLegend
} from "ng-apexcharts";
import { date } from 'ngx-custom-validators/src/app/date/validator';
import { TareasXUsuario } from 'app/oDres/modelos/Empresa/tareasXUsuario';
import { GeneralesService, SelectedFiles } from 'app/shared/services/general.service';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
  tooltip: ApexTooltip;
  fill: ApexFill;
  legend: ApexLegend;
};

@Component({
  selector: 'app-admin-tareas',
  templateUrl: './admin-tareas.component.html',
  styleUrls: ['./admin-tareas.component.scss']
})
export class AdminTareasComponent implements OnInit {
  
  @ViewChild("chart1") chart1: ChartComponent;

  @ViewChild("chart2") chart2: ChartComponent;
  
  tareasEnElAnoOptions : Partial<ChartOptions>;
  tareasPorPrioridad : Partial<ChartOptions>;

  prioridadSeleccionado: PrioridadTarea = {} as PrioridadTarea;
  listaPrioridad: PrioridadTarea[] = [];

  usuarioDirigidoSeleccionado: Usuario = {} as Usuario;
  listaUsuarioDirigido: Usuario[] = [];

  listaEstatusTarea = [];
  tarea: Tareas = {};

  public rows = [];
  public limitRef = 10;
  pagina = 1;
  TotalRegistros = 0;
  tieneFiltro = false;
  listaTempTareas: UsuariosTareasAdmin[] = [];

  resultadoPaginado: ResultadoPaginado<UsuariosTareasAdmin> = {TotalRegistros: 0, PaginaActual: 0, TamanioPagina: 0, TotalPaginas: 0, Resultado: null};

  //private tempData = [];

  errorTitulo = false;
  errorDescripcion= false;  
  errorPrioridad= false;  

  apretoGuardar = false;

  notaNueva = '';

  TareaSeleccionada = {} as Tareas;

  tareaXDocumentoAgregar = {} as TareasXDocumento;

  selectedFiles: SelectedFiles[] = [];
  
  verGraficas = false;

  year = 0;

  busquedaTarea = null;

  constructor(private spinner: NgxSpinnerService, private authService: AuthService, private router: Router, 
    public generalesService: GeneralesService, private modalService: NgbModal) { 

      this.tareasEnElAnoOptions = {
        series: [{
          name: 'Nuevas',
          data: [],
          color: '#827397'
        }, {
          name: 'En Proceso',
          data: [],
          color: '#4D4C7D'
        }, {
          name: 'Terminadas',
          data: [],
          color: '#363062'
        }],
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          fontFamily: 'Montserrat,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
        },
          plotOptions: {
            bar: {
              horizontal: true
            },
          },
          stroke: {
            width: 1,
            colors: ['#fff']
          },
          xaxis: {
            categories: [],
            labels: {
              formatter: function (val) {
                return val
              }
            }
          },
          yaxis: {
            title: {
              text: undefined
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + ""
              }
            }
          },
          fill: {
            opacity: 1
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 40
          }
      };

      this.tareasPorPrioridad = {
        series: [{
          name: 'Nuevas',
          data: [],
          color: '#827397'
        }, {
          name: 'En Proceso',
          data: [],
          color: '#4D4C7D'
        }, {
          name: 'Terminadas',
          data: [],
          color: '#363062'
        }],
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          fontFamily: 'Montserrat,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
        },
          plotOptions: {
            bar: {
              horizontal: true
            },
          },
          stroke: {
            width: 1,
            colors: ['#fff']
          },
          xaxis: {
            categories: [],
            labels: {
              formatter: function (val) {
                return val
              }
            }
          },
          yaxis: {
            title: {
              text: undefined
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + ""
              }
            }
          },
          fill: {
            opacity: 1
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 40
          }
      };
    }

  ngOnInit(): void {
    
    this.listaPrioridad.push({Id: 0, PrioridadTexto: 'Prioridad', Prioridad: 'default'} as PrioridadTarea);
    this.listaPrioridad.push({Id: 1, PrioridadTexto: 'Normal', Prioridad: 'success'} as PrioridadTarea);
    this.listaPrioridad.push({Id: 2, PrioridadTexto: 'Alta', Prioridad: 'warning'} as PrioridadTarea);
    this.listaPrioridad.push({Id: 3, PrioridadTexto: 'Urgente', Prioridad: 'danger'} as PrioridadTarea);    

    this.year = new Date().getFullYear();
  }

  ngAfterViewInit() { 

    this.obtenerTareasXUsuariosAdmin();  

  }

  obtenerTareasXUsuariosAdmin() {
    this.spinner.show();

    this.generalesService.obtenerTareasXUsuariosAdmin(this.authService.usuarioConectado.Empresa.IdEmpresa).subscribe(resultado => {

      //console.log(resultado);

      if (resultado != null && resultado.code == 200){

        resultado.model.forEach((usuario: UsuariosTareasAdmin) => {

          usuario.usuario.VerTareasNuevas = false;
          usuario.usuario.VerTareasEnProceso = false;
          usuario.usuario.VerTareasTerminadas = false;
          usuario.usuario.EsVisible = true;

        });

        this.listaTempTareas = resultado.model;
        //this.tempData = resultado.model;
        this.rows = resultado.model;
    
        this.generalesService.obtenerEstatusTarea({Activo: true} as EstatusTarea).subscribe(resultadoEstatus => { 

          //console.log(resultadoEstatus);

          if (resultadoEstatus != null && resultadoEstatus.code == 200){

            this.listaEstatusTarea = resultadoEstatus.model;              

            this.renderearGraficas();

            this.spinner.hide();

          } else {

            this.spinner.hide();

          }

        });
      }      
    });
  }

  buscarTareas(event) {
    const val = event.target.value.toLowerCase();

    this.tieneFiltro = false;

    let listaUsuariosTareasAdmin: UsuariosTareasAdmin[] = [];

    this.listaTempTareas.forEach(usuario => {

      const tareasNuevas = usuario.tareasXUsuario.TareasNuevas.filter(function (d: Tareas) {
        return d.TituloTarea.toLowerCase().indexOf(val) !== -1 || !val;
      })

      const tareasEnProceso =usuario.tareasXUsuario.TareasEnProceso.filter(function (d: Tareas) {
        return d.TituloTarea.toLowerCase().indexOf(val) !== -1 || !val;
      })

      const tareasTerminadas =usuario.tareasXUsuario.TareasTerminadas.filter(function (d: Tareas) {
        return d.TituloTarea.toLowerCase().indexOf(val) !== -1 || !val;
      })

      const tareasNormal = usuario.tareasXUsuarioXPrioridad.TareasNormal.filter(function (d: Tareas) {
        return d.TituloTarea.toLowerCase().indexOf(val) !== -1 || !val;
      })

      const tareasAlta =usuario.tareasXUsuarioXPrioridad.TareasAlta.filter(function (d: Tareas) {
        return d.TituloTarea.toLowerCase().indexOf(val) !== -1 || !val;
      })

      const tareasUrgente =usuario.tareasXUsuarioXPrioridad.TareasUrgente.filter(function (d: Tareas) {
        return d.TituloTarea.toLowerCase().indexOf(val) !== -1 || !val;
      })

      let tareasXUsuario: TareasXUsuario = { 
        TareasNuevas: tareasNuevas, 
        TareasNuevasTotal: tareasNuevas.length,
        TareasEnProceso: tareasEnProceso, 
        TareasEnProcesoTotal: tareasEnProceso.length,
        TareasTerminadas: tareasTerminadas,
        TareasTerminadasTotal: tareasTerminadas.length
      }

      let tareasXUsuarioXPrioridad: TareasXUsuario = { 
        TareasNormal: tareasNormal,
        TareasNormalTotal: tareasNormal.length,
        TareasAlta: tareasAlta,
        TareasAltaTotal: tareasAlta.length,
        TareasUrgente: tareasUrgente,
        TareasUrgenteTotal: tareasUrgente.length
      }

      listaUsuariosTareasAdmin.push({usuario: usuario.usuario, tareasXUsuario: tareasXUsuario, tareasXUsuarioXPrioridad: tareasXUsuarioXPrioridad});

      this.rows = listaUsuariosTareasAdmin;

      //this.tieneFiltro = true;

      this.renderearGraficas();
    });

  }

  verTareasNuevas(indexUsuario){

    this.rows[indexUsuario].usuario.VerTareasNuevas = true;  

    this.rows.forEach((row, index) => {

      if (indexUsuario != index) {
        row.usuario.EsVisible = false;
      }            

    });

  }

  ocultarTareasNuevas(indexUsuario){

    //console.log('ocultarTareasNuevas');

    this.rows[indexUsuario].usuario.VerTareasNuevas = false;  

    this.rows.forEach((row, index) => {

      if (indexUsuario != index) {
        row.usuario.EsVisible = true;
      }            

    });

  }

  verTareasEnProceso(indexUsuario){

    this.rows[indexUsuario].usuario.VerTareasEnProceso = true;  

    this.rows.forEach((row, index) => {

      if (indexUsuario != index) {
        row.usuario.EsVisible = false;
      }            

    });

  }

  ocultarTareasEnProceso(indexUsuario){

    //console.log('ocultarTareasEnProceso');

    this.rows[indexUsuario].usuario.VerTareasEnProceso = false;  

    this.rows.forEach((row, index) => {

      if (indexUsuario != index) {
        row.usuario.EsVisible = true;
      }            

    });

  }

  verTareasTerminadas(indexUsuario){

    this.rows[indexUsuario].usuario.VerTareasTerminadas = true;  

    this.rows.forEach((row, index) => {

      if (indexUsuario != index) {
        row.usuario.EsVisible = false;
      }            

    });

  }

  ocultarTareasTerminadas(indexUsuario){

    //console.log('ocultarTareasTerminadas');

    this.rows[indexUsuario].usuario.VerTareasTerminadas = false;  

    this.rows.forEach((row, index) => {

      if (indexUsuario != index) {
        row.usuario.EsVisible = true;
      }            

    });

  }

  updateLimit(limit) {
    this.limitRef = limit.target.value;
    this.obtenerTareasXUsuariosAdmin();
  }

  cambioPagina(page: number) {

    //console.log('cambioPagina');

    this.pagina = page;
    
    this.obtenerTareasXUsuariosAdmin();

  }

  agregarOEditarTarea(content, tarea) {

    //console.log('agregarOEditarTarea');

    this.errorTitulo = false;
    this.errorDescripcion = false;
    this.errorPrioridad = false;

    this.tarea = {
      IdTarea: null, 
      IdEmpresa: this.authService.usuarioConectado.Empresa.IdEmpresa, 
      Prioridad: 'default', 
      IdUsuarioCreaTarea: this.authService.usuarioConectado.Usuario.IdUsuario,
      TareaXUsuarioDirigidoA: []
    }; 

    this.tarea.IdEstatusTarea = this.listaEstatusTarea.find(l => l.Descripcion == 'Pendiente').IdEstatusTarea;

    if (tarea != null) {
      this.tarea = tarea;      
    }       
    
    this.spinner.show();

      this.generalesService.obtenerUsuarioPaginado(999,
        1,
        this.authService.usuarioConectado.Empresa.IdEmpresa,
        null,
        true).subscribe(respuestaUsuarios => {
  
          //console.log(respuestaUsuarios);
  
          if (respuestaUsuarios != null && respuestaUsuarios.code == 200){                            
            
            this.listaUsuarioDirigido = respuestaUsuarios.model.Resultado;
            //this.tempData = this.listaUsuarioDirigido;

            this.listaUsuarioDirigido.forEach(usuario => {

              usuario.seleccionado = false;

            });

            if (this.tarea.IdTarea != null) {

              this.tarea.TareaXUsuarioDirigidoA.forEach(usuarioDirigido => {

                let indexUsuario = this.listaUsuarioDirigido.findIndex(u => u.IdUsuario == usuarioDirigido.IdUsuarioDirigidoA);

                this.listaUsuarioDirigido[indexUsuario].seleccionado = true;

              });
              
            }

            this.modalService.open(content, { backdrop: 'static', centered: true, size: 'xl' });
            
          }

          this.spinner.hide();
  
      });

  }

  seleccionoUsuario(e, usuario){
    //console.log(usuario);

    let indexUsuario = this.listaUsuarioDirigido.findIndex(r => r.IdUsuario == usuario.IdUsuario);     

    if (e === true) { 

      this.tarea.TareaXUsuarioDirigidoA.push({IdUsuarioDirigidoA: usuario.IdUsuario} as TareaXUsuarioDirigidoA);

      this.listaUsuarioDirigido[indexUsuario].seleccionado = true;            

    } else {

      let indexUsuario = this.tarea.TareaXUsuarioDirigidoA.findIndex(u => u.IdUsuarioDirigidoA == usuario.IdUsuario);

      this.tarea.TareaXUsuarioDirigidoA.splice(indexUsuario, 1);

      this.listaUsuarioDirigido[indexUsuario].seleccionado = false;

    }

    //console.log(this.tarea);
  }

  validarTituloTarea() {

    this.errorTitulo = false;

    if (this.apretoGuardar && (this.tarea.TituloTarea == null || this.tarea.TituloTarea == '')){

      this.errorTitulo = true;

    }

  }

  validarDescripcion() {
    this.errorDescripcion = false;

    if (this.apretoGuardar && (this.tarea.DescripcionTarea == null || this.tarea.DescripcionTarea == '')){

      this.errorDescripcion = true;

    }
  }

  validarPrioridad() {

    this.errorPrioridad = false;

    if (this.apretoGuardar && (this.tarea.Prioridad == null || this.tarea.Prioridad == 'default')){

      this.errorPrioridad = true;

    }

  }  

  agregaroactualizartarea() {

    //console.log(this.tarea);

    this.apretoGuardar = true;

    this.validarTituloTarea();
    this.validarDescripcion();
    this.validarPrioridad();

    if (!this.errorTitulo && !this.errorDescripcion && !this.errorPrioridad) {
      if (this.tarea.IdTarea == null) {
        if (this.tarea.TareaXUsuarioDirigidoA.length > 0) {   
    
          this.spinner.show();
    
          this.generalesService.agregarTareas(this.tarea).subscribe(resultadoTarea => {
    
            //console.log(resultadoTarea);
    
            if (resultadoTarea != null && resultadoTarea.code == 200){          
    
              this.generalesService.obtenerTareasXUsuariosAdmin(this.authService.usuarioConectado.Empresa.IdEmpresa).subscribe(resultado => {

                //console.log(resultado);
          
                if (resultado != null && resultado.code == 200){
          
                  resultado.model.forEach((usuario: UsuariosTareasAdmin) => {
          
                    usuario.usuario.VerTareasNuevas = false;
                    usuario.usuario.VerTareasEnProceso = false;
                    usuario.usuario.VerTareasTerminadas = false;
                    usuario.usuario.EsVisible = true;
          
                  });
          
                  //this.listaTempTareas = resultado.model;
                  //this.tempData = resultado.model;
                  this.rows = resultado.model;      
              
                  this.generalesService.obtenerEstatusTarea({Activo: true} as EstatusTarea).subscribe(resultadoEstatus => { 
          
                    //console.log(resultadoEstatus);
          
                    if (resultadoEstatus != null && resultadoEstatus.code == 200){
          
                      this.listaEstatusTarea = resultadoEstatus.model;              
          
                      this.modalService.dismissAll();

                      this.renderearGraficas();
                      
                      this.spinner.hide();
          
                    } else {
          
                      this.spinner.hide();
          
                    }
          
                  });
                }      
              });
    
            } else {
    
              const opciones: SweetAlertOptions = {
                icon: 'error',
                title: 'Error',
                text: resultadoTarea.message,
                type: 'error',
                allowOutsideClick: false,
                allowEscapeKey: false
              } as SweetAlertOptions;
      
              this.spinner.hide();
      
              swal.fire(opciones);
              
            }        
    
          });

        } else {
          const opciones: SweetAlertOptions = {
            icon: 'error',
            title: 'Selecciona una asignación',
            text: "Debes asignar a al menos una persona la tarea",
            type: 'error',
            allowOutsideClick: false,
            allowEscapeKey: false
          } as SweetAlertOptions;        
  
          swal.fire(opciones);
        }
    
      } else {      

        if (this.tarea.TareaXUsuarioDirigidoA.length > 0) {

          this.generalesService.actualizarTareasAdministrador(this.tarea).subscribe(resultadoTarea => {
  
            //console.log(resultadoTarea);
    
            if (resultadoTarea != null && resultadoTarea.code == 200){
              this.generalesService.obtenerTareasXUsuariosAdmin(this.authService.usuarioConectado.Empresa.IdEmpresa).subscribe(resultado => {

                //console.log(resultado);
          
                if (resultado != null && resultado.code == 200){
          
                  resultado.model.forEach((usuario: UsuariosTareasAdmin) => {
          
                    usuario.usuario.VerTareasNuevas = false;
                    usuario.usuario.VerTareasEnProceso = false;
                    usuario.usuario.VerTareasTerminadas = false;
                    usuario.usuario.EsVisible = true;
          
                  });
          
                  //this.listaTempTareas = resultado.model;
                  //this.tempData = resultado.model;
                  this.rows = resultado.model;      
              
                  this.generalesService.obtenerEstatusTarea({Activo: true} as EstatusTarea).subscribe(resultadoEstatus => { 
          
                    //console.log(resultadoEstatus);
          
                    if (resultadoEstatus != null && resultadoEstatus.code == 200){
          
                      this.listaEstatusTarea = resultadoEstatus.model;       
                      
                      this.modalService.dismissAll();
          
                      this.spinner.hide();
          
                    } else {
          
                      this.spinner.hide();
          
                    }
          
                  });
                }      
              });
              
            } else {

              const opciones: SweetAlertOptions = {
                icon: 'error',
                title: 'Error',
                text: resultadoTarea.message,
                type: 'error',
                allowOutsideClick: false,
                allowEscapeKey: false
              } as SweetAlertOptions;
      
              this.spinner.hide();
      
              swal.fire(opciones);
            }        
    
          });
        } else {
    
          const opciones: SweetAlertOptions = {
            icon: 'error',
            title: 'Selecciona una asignación',
            text: "Debes asignar a al menos una persona la tarea",
            type: 'error',
            allowOutsideClick: false,
            allowEscapeKey: false
          } as SweetAlertOptions;        
  
          swal.fire(opciones);
          
        }  
  
        
      }
            
    }         

  }

  actualizarTarea(tarea: Tareas) {
    this.spinner.show();

    this.generalesService.actualizarTareas({ IdTarea: tarea.IdTarea, IdEmpresa: tarea.IdEmpresa, Activo: false } as Tareas).subscribe(resultado => {

      //console.log(resultado);

      if (resultado != null && resultado.code == 200) {

        this.generalesService.obtenerTareasXUsuariosAdmin(this.authService.usuarioConectado.Empresa.IdEmpresa).subscribe(resultado => {

          //console.log(resultado);
    
          if (resultado != null && resultado.code == 200){
    
            resultado.model.forEach((usuario: UsuariosTareasAdmin) => {
    
              usuario.usuario.VerTareasNuevas = false;
              usuario.usuario.VerTareasEnProceso = false;
              usuario.usuario.VerTareasTerminadas = false;
              usuario.usuario.EsVisible = true;
    
            });
    
            //this.listaTempTareas = resultado.model;
            //this.tempData = resultado.model;
            this.rows = resultado.model;        
        
            this.generalesService.obtenerEstatusTarea({Activo: true} as EstatusTarea).subscribe(resultadoEstatus => { 
    
              //console.log(resultadoEstatus);
    
              if (resultadoEstatus != null && resultadoEstatus.code == 200){
    
                this.listaEstatusTarea = resultadoEstatus.model;              
    
                this.spinner.hide();
    
              } else {
    
                this.spinner.hide();
    
              }
    
            });
          }      
        });  

      } else {

        const opciones: SweetAlertOptions = {
          icon: 'error',
          title: 'Error',
          text: resultado.message,
          type: 'error',
          allowOutsideClick: false,
          allowEscapeKey: false
        } as SweetAlertOptions;

        this.spinner.hide();

        swal.fire(opciones);

      }

    });

  }

  abrirNotas(content, tarea) {
    this.notaNueva = '';
    this.TareaSeleccionada = tarea;
    this.modalService.open(content, { backdrop: 'static', centered: true });
  }

  abrirDocumentos(content, tarea) {
    this.TareaSeleccionada = tarea;

    this.tareaXDocumentoAgregar = { 
      IdTarea: this.TareaSeleccionada.IdTarea,
      IdUsuario: this.authService.usuarioConectado.Usuario.IdUsuario,
      Nota: '',
      ListaDocumentos: []
     } as TareasXDocumento;

    this.modalService.open(content, { backdrop: 'static', centered: true, windowClass: 'agregarDocumentostarea' });
  }

  agregarArchivos() {

    //console.log('agregarArchivos');
   
    this.spinner.show();

    this.selectedFiles.forEach(file => {

      this.tareaXDocumentoAgregar.ListaDocumentos.push({ 
        id: file.id,
        nombreArchivo: file.name, 
        esImagen: false, 
        archivo: file.base64
        .replace('data:text/plain;base64,', '')
        .replace('data:image/jpeg;base64,', '')
        .replace('data:image/png;base64,', '')
        .replace('data:application/pdf;base64,', '')
        .replace('data:application/vnd.openxmlformats-officedocument.presentationml.presentation;base64,', '')
        .replace('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,', '')
        .replace('data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,', ''),
        contenedor: this.authService.usuarioConectado.Empresa.Identificador.toLocaleLowerCase().trim()  
      } as Documento);

    });

    this.tareaXDocumentoAgregar 

    this.generalesService.agregarTareaXDocumento(this.tareaXDocumentoAgregar).subscribe(resultado => {

      //console.log(resultado);

      if (resultado != null && resultado.code == 200){

        this.tareaXDocumentoAgregar = { 
          IdTarea: this.TareaSeleccionada.IdTarea,
          IdUsuario: this.authService.usuarioConectado.Usuario.IdUsuario,
          Nota: '',
          ListaDocumentos: []
         } as TareasXDocumento;

        this.selectedFiles = [];        

        let indexTarea = this.authService.usuarioConectado.tareasXUsuario.TareasEnProceso.findIndex(t => t.IdTarea == this.TareaSeleccionada.IdTarea);

        if (indexTarea > -1){
          this.authService.usuarioConectado.tareasXUsuario.TareasEnProceso[indexTarea] = resultado.model[0];
        } else {
          indexTarea = this.authService.usuarioConectado.tareasXUsuario.TareasTerminadas.findIndex(t => t.IdTarea == this.TareaSeleccionada.IdTarea);

          this.authService.usuarioConectado.tareasXUsuario.TareasTerminadas[indexTarea] = resultado.model[0];
        }

        this.TareaSeleccionada = resultado.model[0];

        this.spinner.hide();
      } else {

        const opciones: SweetAlertOptions = {
          icon: 'error',
          title: 'Error',
          text: resultado.message,
          type: 'error',
          allowOutsideClick: false,
          allowEscapeKey: false
        } as SweetAlertOptions;

        this.spinner.hide();

        swal.fire(opciones);

      }

    });


  }

  onSelectFile(event, files) {
    //console.log('onSelectFile');

    this.spinner.show();

    this.generalesService.toBase64(files, this.selectedFiles).subscribe((res) => {
      if (res) {
        this.selectedFiles = res;
        //console.log(this.selectedFiles);
        event.value = null;
        this.spinner.hide();
      }
    });

  }

  cerrarArchivos() { 
    this.tareaXDocumentoAgregar.Nota = '';
    this.selectedFiles = [];     

    
    this.modalService.dismissAll();
  }

  eliminarDocumento(documento) {

    const opciones: SweetAlertOptions = {
      icon: 'question',
      title: 'Eliminar documento',
      text: 'El documento ' + documento.NombreDocumento + ' sera eliminado, ¿Deseas continuar?',
      type: 'warning',
      showCancelButton: true,
      cancelButtonText: 'No',
      confirmButtonText: 'Sí',
      confirmButtonColor: '#30d65f',
      cancelButtonColor: '#d64130',
      allowOutsideClick: false,
      allowEscapeKey: false
    } as SweetAlertOptions;

    swal.fire(opciones).then((resultado) => {
      if (resultado.value) {

        this.generalesService.eliminarDocumento({Id: documento.Id, IdTarea: this.TareaSeleccionada.IdTarea} as TareasXDocumento).subscribe(resultado => {

          //console.log(resultado);

          if (resultado != null && resultado.code == 200) {

            // let indexTarea = this.authService.usuarioConectado.tareasXUsuario.TareasEnProceso.findIndex(t => t.IdTarea == this.TareaSeleccionada.IdTarea);

            // if (indexTarea > -1){
            //   this.authService.usuarioConectado.tareasXUsuario.TareasEnProceso[indexTarea] = resultado.model[0];
            // } else {
            //   indexTarea = this.authService.usuarioConectado.tareasXUsuario.TareasTerminadas.findIndex(t => t.IdTarea == this.TareaSeleccionada.IdTarea);

            //   this.authService.usuarioConectado.tareasXUsuario.TareasTerminadas[indexTarea] = resultado.model[0];
            // }

            this.TareaSeleccionada = resultado.model[0];

            this.spinner.hide();

          } else {

            const opciones: SweetAlertOptions = {
              icon: 'error',
              title: 'Error',
              text: resultado.message,
              type: 'error',
              allowOutsideClick: false,
              allowEscapeKey: false
            } as SweetAlertOptions;
    
            this.spinner.hide();
    
            swal.fire(opciones);
    
          }

        });

      }
    });

  }

  verGraficasTareas(){

    this.verGraficas = true;
    this.renderearGraficas();
  }

  verTareas() {
    this.verGraficas = false;
  }

  renderearGraficas(){

    if (this.verGraficas) {      
          
      let dataNuevas = [];
      let dataEnProceso = [];
      let dataTerminadas = [];
      let dataUsuarios = [];

      let dataNormal = [];
      let dataAlta= [];
      let dataUrgente = [];

      this.rows.forEach(row => {

        dataUsuarios.push(row.usuario.NombreCompleto);
        dataNuevas.push(row.tareasXUsuario.TareasNuevasTotal);
        dataEnProceso.push(row.tareasXUsuario.TareasEnProcesoTotal);
        dataTerminadas.push(row.tareasXUsuario.TareasTerminadasTotal);

        dataNormal.push(row.tareasXUsuarioXPrioridad.TareasNormalTotal);
        dataAlta.push(row.tareasXUsuarioXPrioridad.TareasAltaTotal);
        dataUrgente.push(row.tareasXUsuarioXPrioridad.TareasUrgenteTotal);

      });

      this.tareasEnElAnoOptions = {};
      this.tareasPorPrioridad = {};

      this.tareasEnElAnoOptions = {
        series: [{
          name: 'Nuevas',
          data: dataNuevas,
          color: '#827397'
        }, {
          name: 'En Proceso',
          data: dataEnProceso,
          color: '#4D4C7D'
        }, {
          name: 'Terminadas',
          data: dataTerminadas,
          color: '#363062'
        }],
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          fontFamily: 'Montserrat,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif'
        },
          plotOptions: {
            bar: {
              horizontal: true
            },
          },
          stroke: {
            width: 1,
            colors: ['#fff']
          },
          xaxis: {
            categories: dataUsuarios,
            labels: {
              formatter: function (val) {
                return val
              }
            }
          },
          yaxis: {
            title: {
              text: undefined
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + ""
              }
            }
          },
          fill: {
            opacity: 1
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 40
          }
      };

      this.tareasPorPrioridad = {
          series: [{
          name: 'Normal',
          data: dataNormal,
          color: '#28B463'
          }, {
            name: 'Alta',
            data: dataAlta,
            color: '#CA6F1E'
          }, {
            name: 'Urgente',
            data: dataUrgente,
            color: '#A93226'
          }],
        chart: {
          type: 'bar',
          height: 350,
          stacked: true
        },
          plotOptions: {
            bar: {
              horizontal: true
            },
          },
          stroke: {
            width: 1,
            colors: ['#fff']
          },
          xaxis: {
            categories: dataUsuarios,
            labels: {
              formatter: function (val) {
                return val
              }
            }
          },
          yaxis: {
            title: {
              text: undefined
            },
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + ""
              }
            }
          },
          fill: {
            opacity: 1
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 40,

          }
      };
      
    }
  }
}
